import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher({ viewer }) {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        // This changes the language for our React components
        i18n.changeLanguage(lng);
        
        // This also tells the underlying Potree instance to change its language
        // for any text it might generate (e.g., default measurement names)
        if (viewer) {
            viewer.setLanguage(lng);
        }
    };

    return (
        <div className="language-switcher">
            <button onClick={() => changeLanguage('en')} disabled={i18n.language === 'en'}>EN</button>
            <button onClick={() => changeLanguage('fr')} disabled={i18n.language === 'fr'}>FR</button>
            <button onClick={() => changeLanguage('de')} disabled={i18n.language === 'de'}>DE</button>
        </div>
    );
}